/*  100 % AJAX cart – zero redirect, zero popup  */
(function () {
  'use strict';

  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  const API = {
    get : () => fetch('/cart.js').then(r => r.json()),
    add : items => fetch('/cart/add.js', {
                      method : 'POST',
                      headers: {'Content-Type': 'application/json'},
                      body   : JSON.stringify({items})
                    }).then(r => { if (!r.ok) throw r; return r.json(); })
                      .then(() => API.get()),
    change: (id, qty) => fetch('/cart/change.js', {
                              method : 'POST',
                              headers: {'Content-Type': 'application/json'},
                              body   : JSON.stringify({id, quantity: qty})
                          }).then(r => { if (!r.ok) throw r; return r.json(); })
                            .then(() => API.get())
  };

  /*  ----  drawer  ----  */
  function renderDrawer(cart) {
    let d = $('#AjaxCartDrawer');
    if (!d) {
      d = document.createElement('div');
      d.id = 'AjaxCartDrawer';
      d.className = 'ajax-cart-drawer';
      d.innerHTML = `
        <div class="ajax-cart-header">
          <span>Cart</span>
          <button class="ajax-cart-close" aria-label="Close">&times;</button>
        </div>
        <div class="ajax-cart-body"></div>
        <div class="ajax-cart-footer"></div>`;
      document.body.appendChild(d);
      $('.ajax-cart-close', d).onclick = () => d.classList.remove('open');
      document.addEventListener('keydown', e => { if (e.key === 'Escape') d.classList.remove('open'); });
    }
    const body = $('.ajax-cart-body', d);
    const foot = $('.ajax-cart-footer', d);

    body.innerHTML = cart.items.length
      ? cart.items.map(item => `
          <div class="ajax-cart-item" data-key="${item.key}">
            <img src="${item.image}" alt="">
            <div>
              <strong>${item.product_title}</strong><br>
              ${item.variant_title} × ${item.quantity}<br>
              $${(item.line_price / 100).toFixed(2)}
            </div>
            <button class="ajax-cart-remove" data-key="${item.key}">×</button>
          </div>`).join('')
      : `<p class="ajax-cart-empty">Your cart is empty</p>`;

    foot.innerHTML = `
      <div class="ajax-cart-total">
        <span>Total</span><strong>$${(cart.total_price / 100).toFixed(2)}</strong>
      </div>
      <div class="ajax-cart-actions">
        <a href="/cart" class="ajax-cart-btn secondary">View cart</a>
        <a href="/checkout" class="ajax-cart-btn primary">Check out</a>
      </div>`;

    d.classList.toggle('has-items', cart.items.length > 0);
    window.updateCartCount?.(cart.item_count);
    d.classList.add('open');
  }

  /*  ----  FILE SUPPORT (.sdf added)  ----  */

  const allowedExtensions = [
    '.png',
    '.jpg',
    '.jpeg',
    '.webp',
    '.svg',
    '.pdf',
    '.sdf'   // ← NEW SUPPORT
  ];

  function isValidFile(file) {
    const ext = '.' + file.name.split('.').pop().toLowerCase();
    return allowedExtensions.includes(ext);
  }

  /*  ----  upload handler (supports sdf)  ----  */

  window.handleDesignUpload = function(input, type) {
    const file = input.files[0];
    if (!file) return;

    if (!isValidFile(file)) {
      alert('Unsupported file format. Allowed: PNG, JPG, SVG, PDF, SDF');
      input.value = '';
      return;
    }

    const preview = document.querySelector(`#preview-${type}`);

    // Show preview for sdf
    if (file.name.toLowerCase().endsWith('.sdf')) {
      if (preview) {
        preview.innerHTML = `
          <div class="file-preview">
            📄 ${file.name}
          </div>`;
      }
    }

    // Upload file (imgbb or your uploader)
    uploadToImgBB(file)
      .then(url => {

        if (type === 'front') {
          document.getElementById('customDesignFront').value = url;
          window.__uploadedOriginalFront = url;
        }

        if (type === 'back') {
          document.getElementById('customDesignBack').value = url;
          window.__uploadedOriginalBack = url;
        }

      })
      .catch(() => alert('Upload failed'));
  };

  /*  ----  IMGBB Upload ----  */

  async function uploadToImgBB(file) {

    const apiKey = window.IMGBB_API_KEY;
    const formData = new FormData();

    formData.append('image', file);

    const res = await fetch(`https://api.imgbb.com/1/upload?key=${apiKey}`, {
      method: 'POST',
      body: formData
    });

    const data = await res.json();

    if (!data.success) throw new Error('Upload failed');

    return data.data.url;
  }

  /*  ----  build payload  ----  */

  window.buildAddPayload = function () {
    const color = (window.getSelectedModalColorValue?.() || window.getSelectedColorFromForm?.() || 'Black');
    const back  = $('#backViewFrontBack')?.checked ? 'Front and Back Design' : 'Front Design Only';
    const sizes = Object.entries(window.selectedSizes || {}).filter(([,q]) => q > 0);

    if (!sizes.length) throw new Error('Please select at least one size/quantity');

    return sizes.map(([size, qty]) => {

      const v = window.findVariant(
        String(color.value || color).toLowerCase().trim(),
        String(size).toLowerCase().trim(),
        String(back).toLowerCase().trim()
      );

      if (!v) throw new Error(`Variant not available: ${color} / ${size} / ${back}`);

      const frontDesign = document.getElementById('customDesignFront')?.value || '';
      const backDesign  = document.getElementById('customDesignBack')?.value || '';

      return {
        id        : v.id,
        quantity  : qty,
        properties: {
          _custom_order: 'Yes',
          _back_view   : back.includes('Back') ? 'Yes' : 'No',
          _color       : color,
          _size        : size,
          _session_id  : window.__sessionId,

          ...(frontDesign ? { _design_front: frontDesign } : {}),
          ...(backDesign  ? { _design_back:  backDesign  } : {}),

          _original_front: window.__uploadedOriginalFront || '',
          _original_back : window.__uploadedOriginalBack  || '',
        }
      };
    });
  };

  /*  ----  main click  ----  */

  async function handleAdd() {
    const btn = $('[data-ajax-add]');
    if (!btn) return;

    const orig = btn.textContent;

    btn.textContent = 'Adding…';
    btn.disabled = true;

    try {
      const items = window.buildAddPayload();
      const cart  = await API.add(items);

      renderDrawer(cart);
      $('#customizationModal')?.classList.remove('show');

    } catch (e) {

      const msg = (await e.json?.())?.description || e.message || 'Error';
      alert(msg);

    } finally {

      btn.textContent = orig;
      btn.disabled = false;

    }
  }

  /*  ----  listeners  ----  */

  document.addEventListener('click', e => {

    const t = e.target;

    if (t.classList.contains('ajax-cart-remove')) {

      e.preventDefault();

      const item = t.closest('.ajax-cart-item');

      if (item) item.style.opacity = '0.5';

      API.change(t.dataset.key, 0).then(renderDrawer);

    }

    if (t.closest('[data-ajax-add]')) {

      e.preventDefault();
      handleAdd();

    }

  });

  /*  ----  block old submits  ----  */

  document.addEventListener('submit', e => {

    const f = e.target;

    if (f.id === 'AddToCartForm' || f.matches('.product-form, [action*="/cart"]')) {

      e.preventDefault();
      e.stopImmediatePropagation();

    }

  }, true);

  /*  ----  open drawer ----  */

  window.openAjaxCartDrawer = function() {

    return API.get()
      .then(cart => {
        renderDrawer(cart);
        return true;
      })
      .catch(err => {
        console.error('Failed to open cart drawer:', err);
        return false;
      });

  };

})();